module.exports = __webpack_public_path__ + "img/google-play-store-mobile.f28622c7.png";